<template>
    <div v-if="isMounted" id="supplier-bank-account-notif" class="vx-row">
        <div v-if="!supplierBankAccountMissing" class="mb-2 h-auto vx-col w-full">
            <vs-alert 
                v-for="account in accountToShow" 
                :key="account.id" 
                @click.stop="goToProfile()"
                :color="getColor(account)" 
                active="true" 
                icon-pack="feather"
                :icon="getIcon(account)"
                class="mb-4 h-auto clickable-img">
                <p v-html="getStatusText(account)"></p>
            </vs-alert>
        </div>
        <div v-else class="mb-2 h-auto vx-col w-full">
            <vs-alert 
                @click.stop="goToProfile()"
                color="warning" 
                active="true" 
                icon-pack="feather"
                icon="icon-alert-circle"
                class="mb-4 h-auto clickable-img">
                <p>Aún no tienes una cuenta bancaria registrada. Por favor, <strong><u>registra una cuenta</u></strong> para recibir tus pagos.</p>
            </vs-alert>
        </div>
    </div>
</template>

<script>
    import formatHelper from '@mixins/formatHelper.js';
    export default {
        mixins: [formatHelper],
        data: () => ({
            bankAccounts: [],
            accountToShow: [],
            isMounted: false,
            supplierBankAccountMissing: false
        }),
        mounted() {
            this.getUserAccounts();
        },
        methods: {
            async getUserAccounts() {
                try {
                    const res = await axios.get(`api/app/bank-account`);
                    const accs = res.data;
                    this.bankAccounts = accs;
                    if (accs.length == 0) {
                        this.supplierBankAccountMissing = true;
                    }
                    this.accountToShow = accs.filter(acc => (acc.verified != 'verified' && acc.verified != 'rejected'));
                    this.isMounted = true;

                } catch (e) { }
            },
            getStatusText(tr) {
                let text = `Tu cuenta CLABE <strong>${tr.bank.short_name} ${this.anonymousFormatCLABE(tr.clabe)}</strong> está pendiente de <strong>revisión</strong>. Te notificaremos por correo en cuanto verifiquemos tu cuenta.`;
                if (tr.verified == 'unverified') {
                    text = `Tu cuenta CLABE <strong>${tr.bank.short_name} ${this.anonymousFormatCLABE(tr.clabe)}</strong> está en <strong>revisión</strong>. Te notificaremos por correo en cuanto verifiquemos tu cuenta.`;
                } else if (tr.verified == 'rejected') {
                    if(tr.stp_verification_replay != null && tr.stp_verification_replay != undefined && tr.stp_verification_replay != '') {
                        text = `Tu cuenta CLABE <strong>${tr.bank.short_name} ${this.anonymousFormatCLABE(tr.clabe)}</strong> fue <strong>rechazada</strong>. ${tr.stp_verification_replay}`;
                    } else {
                        text = `Tu cuenta CLABE <strong>${tr.bank.short_name} ${this.anonymousFormatCLABE(tr.clabe)}</strong> fue <strong>rechazada</strong>. Por favor, verifica que la información de tu cuenta bancaria sea correcta y vuelve a intentarlo.`;
                    }
                }
                return `${text} <strong><u>Ir al perfil.</u></strong>`;
            },
            getColor(tr) {
                let color = 'warning';
                if (tr.verified == 'verified') {
                    color = 'success';
                } else if (tr.verified == 'rejected') {
                    color = 'danger';
                }
                return color;
            },
            getIcon(tr) {
                let icon = 'icon-alert-circle';
                if (tr.verified == 'verified') {
                    icon = 'icon-check-circle';
                } else if (tr.verified == 'rejected') {
                    icon = 'icon-x-circle';
                }
                return icon;
            },
            async goToProfile() {
                await this.$router.push({ name: 'perfil-editar' })
            },
        }
    }
</script>